import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { DebtCard } from '@/components/debts/DebtCard';
import { EmptyState } from '@/components/ui/EmptyState';
import { useDebts } from '@/hooks/useDebts';

export function DebtsPage() {
  const { data: debts, isLoading } = useDebts();

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-xl font-semibold">Deudas</h1>
          <p className="text-sm text-muted-foreground">Tarjetas, créditos y lo que te falta por pagar.</p>
        </div>
        <Link to="/deudas/nueva" className="shrink-0">
          <Button className="w-full sm:w-auto">
            <Plus size={16} /> Nueva deuda
          </Button>
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-muted-foreground">Cargando…</p>
      ) : debts && debts.length > 0 ? (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {debts.map((debt) => (
            <DebtCard key={debt.id} debt={debt} />
          ))}
        </div>
      ) : (
        <EmptyState
          title="No tienes deudas registradas"
          description="Crea la primera para empezar a ver tu proyección de pago."
          action={
            <Link to="/deudas/nueva">
              <Button size="sm">Crear deuda</Button>
            </Link>
          }
        />
      )}
    </div>
  );
}
